import { useToast } from "@/hooks/use-toast";
import { useLarguraSm } from "@/hooks/useLarguraSm";
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast";

export function Toaster() {
  const { toasts } = useToast();
  // Parte D1: deslizar para fechar acompanha a posição — para cima no celular (o aviso fica
  // no topo), para a direita no computador (canto inferior direito).
  const largo = useLarguraSm();

  return (
    <ToastProvider label="Aviso" swipeDirection={largo ? "right" : "up"}>
      {toasts.map(function ({ id, title, description, action, conteudo, ...props }) {
        // Parte D1: quem traz o próprio miolo (o aviso de notificação) monta o conteúdo.
        if (conteudo) {
          return (
            <Toast key={id} {...props}>
              {conteudo}
            </Toast>
          );
        }
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && <ToastDescription>{description}</ToastDescription>}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport label="Avisos ({hotkey})" />
    </ToastProvider>
  );
}
